import { render, staticRenderFns } from "./SubmitForm.vue?vue&type=template&id=062fef59&scoped=true"
import script from "./SubmitForm.vue?vue&type=script&lang=js"
export * from "./SubmitForm.vue?vue&type=script&lang=js"
import style0 from "./SubmitForm.vue?vue&type=style&index=0&id=062fef59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062fef59",
  null
  
)

export default component.exports